import React, { useState, useEffect } from "react";
import { Accordion, AccordionSummary, AccordionDetails, Typography } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

interface CustomAccordionProps {
    title: string;
    children: React.ReactNode;
    expandedDefault: boolean;
    expanded?: boolean;
    onExpandedChange?: (expanded: boolean) => void;
    titleColor?: string; // Color del título, opcional
    headerBgColor?: string; // Color de fondo del header cuando está expandido
    collapsedBgColor?: string; // Color de fondo cuando está cerrado
}

const CustomAccordion: React.FC<CustomAccordionProps> = ({
    title,
    children,
    expandedDefault,
    expanded,
    onExpandedChange,
    titleColor = "#000", 
    headerBgColor = "#e0e0e0",
    collapsedBgColor = "#fff" 
}) => {
    const [internalExpanded, setInternalExpanded] = useState<boolean>(expandedDefault);

    // Sincronizar con el prop expanded si se proporciona
    useEffect(() => {
        if (expanded !== undefined) {
            setInternalExpanded(expanded);
        }
    }, [expanded]);

    const handleChange = () => {
        const newExpanded = !internalExpanded;
        setInternalExpanded(newExpanded);
        if (onExpandedChange) {
            onExpandedChange(newExpanded);
        }
    };

    return (
        <Accordion expanded={internalExpanded} onChange={handleChange} >
            <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                sx={{
                    backgroundColor: internalExpanded ? headerBgColor : collapsedBgColor,
                    transition: "background-color 0.3s ease",
                }}
            >
                <Typography variant="h6" sx={{ color: titleColor }}>
                    {title}
                </Typography>
            </AccordionSummary>
            {internalExpanded ? <AccordionDetails>{children}</AccordionDetails> : null}
        </Accordion>
    );
};

export default CustomAccordion;
